import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import UserFormSections from "./UserFormSections.js"


class Unlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pk: null,
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    ResetForm() {
        this.setState({
            grupo_id: null,
            departamento_id: null,
            departamentopadre_id: null,
            pk: null,
        });
    }

    setSelects(data) {
        this.setState({
            pk: data.pk,
            grupo_id: data.grupo_id,
            departamento_id: data.departamento_id,
            departamentopadre_id: data.departamentopadre_id
        });
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.usuarios.usuarios.unlock}
                postUrl={api.usuarios.usuarios.unlock}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Usuario ha sido habilitado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Habilitar login de Usuario"}
                buttonTitle={"Habilitar login Usuario"}
                buttonIcon={"fa fa-unlock fa-lg"}
                className={"ui-modal-dialog ui-modal-lg"}

                saveButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.ResetForm()}
                closeButton={true}>
                <div className="ui-form">
                    <div className="ui-alert ui-alert-success">
                        <i className="ti ti-lock-open" aria-hidden="true"></i>
                        Se habilitará el login del usuario seleccionado.
                    </div>
                    <UserFormSections
                        disabled={true}
                        departamentoId={this.state.departamento_id}
                        departamentoPadreId={this.state.departamentopadre_id}
                        onGrupoChange={(data) => this.setState({ departamentopadre_id: (data != null ? data.pk : 0), departamento_id: null })}
                        onSubgrupoChange={(data) => this.setState({ departamento_id: (data != null ? data.pk : 0) })}
                    />
                </div>
            </ParadigmaModal>
        );
    }
}

export default Unlock;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Usuarios/Unlock.js